document.addEventListener("DOMContentLoaded", function () {
  let appointmentButtons = document.querySelectorAll('.btn.btn-cal'),
      callButtons = document.querySelectorAll('.btn.btn-phone');

  appointmentButtons.forEach((appointmentButton) => {
    appointmentButton.addEventListener('click', function (e) {
      try {
        dataLayer.push({'event': 'ClickToAppointmentFunnel'});
      } catch (e) {
      }
    });
  });

  callButtons.forEach((callButton) => {
    callButton.addEventListener('click', function (e) {
      try {
        dataLayer.push({'event': 'callButton'});
      } catch (e) {
      }
    });
  });

  document.getElementById('contact-form').onsubmit = function(e) {
    try {
      dataLayer.push({'event': 'contactSubmit'});
    } catch (e) {
    }
  }
});